// extracted by mini-css-extract-plugin
export default {"autoCompleteStyles":"GlobalAutoComplate_autoCompleteStyles__F71Fv","chip":"GlobalAutoComplate_chip__Eh4Af"};